<template>
  <div :class="$style.root">
    <template v-for="item in checkedSexItem" :key="item.value">
      <MoleculesConsumerTagButton show-delete @on-delete="emit('removeTag', 'sex', item.value)">
        {{ item.key }}
      </MoleculesConsumerTagButton>
    </template>
    <template v-for="item in checkedHeightItem" :key="item.value">
      <MoleculesConsumerTagButton show-delete @on-delete="emit('removeTag', 'height', item.value)">
        {{ item.key }}
      </MoleculesConsumerTagButton>
    </template>
    <template v-for="item in checkedWeightItem" :key="item.value">
      <MoleculesConsumerTagButton show-delete @on-delete="emit('removeTag', 'weight', item.value)">
        {{ item.key }}
      </MoleculesConsumerTagButton>
    </template>
    <template v-for="item in checkedFootItem" :key="item.value">
      <MoleculesConsumerTagButton show-delete @on-delete="emit('removeTag', 'foot', item.value)">
        {{ item.key }}
      </MoleculesConsumerTagButton>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { FilterCategoryType } from "~/types/review"

type TagItem = { key: string; value: string; checked: boolean }
const props = defineProps<{
  sexItem: TagItem[]
  heightItem: TagItem[]
  weightItem: TagItem[]
  footItem: TagItem[]
}>()

const checkedSexItem = computed(() => props.sexItem.filter((el) => el.checked))
const checkedHeightItem = computed(() => props.heightItem.filter((el) => el.checked))
const checkedWeightItem = computed(() => props.weightItem.filter((el) => el.checked))
const checkedFootItem = computed(() => props.footItem.filter((el) => el.checked))

const emit = defineEmits<{
  (e: "removeTag", target: FilterCategoryType, itemValue: string): void
}>()
</script>

<style lang="scss" scoped module>
.root {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
